import React from "react";

const Bash_Awk = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Awk</h2>
      <p>
        Pattern scanning and processing language. Great for column extraction
        and reports.
      </p>

      <p>awk is powerful; use for structured text processing.</p>
    </div>
  );
};

export default Bash_Awk;
